import React, { ReactNode } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import clsx from "clsx";
import WhiteTextBox, { IWhiteTextBoxClasses } from "./WhiteTextBox";
import Rotate from "components/rotate/Rotate";
import controllerIconImage from "assets/images/icons/icon_controller.png";
import warningIconImage from "assets/images/icons/icon_warning.png";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
        },
        titleContainer: {
            position: "relative",
            zIndex: 1000,
            display: "flex",
            alignItems: "flex-end",
            "& img": { width: "100%" },
        },
        title: {
            zIndex: 100,
        },
        titlePrefix: {
            flex: "1",
        },
        titleSuffix: {},
        textBox: { marginTop: -12, width: "95%" },
        icon: {
            marginLeft: "-6%",

            [theme.breakpoints.down("sm")]: { "& img": { width: 115 } },
            [theme.breakpoints.down("xs")]: { "& img": { width: "20vw" } },
        },
    });
});

export enum WhiteTextBoxWithAdornmentsIcons {
    CONTROLLER = "CONTROLLER",
    WARNING = "WARNING",
}

type IClasses = Partial<ReturnType<typeof useStyles>>;

interface IProps extends React.HTMLAttributes<HTMLDivElement> {
    children?: ReactNode;
    titlePrefixComponent?: ReactNode;
    titleSuffixComponent?: ReactNode;
    textContainerClasses?: IWhiteTextBoxClasses;
    classes?: IClasses;
    icon?: WhiteTextBoxWithAdornmentsIcons;
}

export default function WhiteTextBoxWithAdornments(props: IProps) {
    const classes = useStyles();
    const {
        className,
        children,
        titlePrefixComponent,
        titleSuffixComponent,
        textContainerClasses,
        classes: overrideClasses,
        icon = WhiteTextBoxWithAdornmentsIcons.CONTROLLER,
        ...rest
    } = props;

    let iconComponent = (
        <Rotate amount={10}>
            <img src={controllerIconImage} alt="Controller Icon" style={{ maxWidth: 125 }} />
        </Rotate>
    );

    if (icon === WhiteTextBoxWithAdornmentsIcons.WARNING) {
        iconComponent = <img src={warningIconImage} alt="Warning Icon" style={{ maxWidth: 80 }} />;
    }

    return (
        <div className={clsx(className, classes.root, overrideClasses?.root)} {...rest}>
            <div className={clsx(classes.titleContainer, overrideClasses?.titleContainer)}>
                <div
                    className={clsx(
                        classes.title,
                        overrideClasses?.title,
                        classes.titlePrefix,
                        overrideClasses?.titlePrefix
                    )}
                >
                    <Rotate amount={-1.5}>{titlePrefixComponent}</Rotate>
                </div>
                <div className={clsx(classes.icon, overrideClasses?.icon)}>{iconComponent}</div>

                {typeof titleSuffixComponent === "undefined" ? null : (
                    <div
                        className={clsx(
                            classes.title,
                            overrideClasses?.title,
                            classes.titleSuffix,
                            overrideClasses?.titleSuffix
                        )}
                    >
                        {titleSuffixComponent}
                    </div>
                )}
            </div>
            <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <div className={clsx(classes.textBox, overrideClasses?.textBox)}>
                    <WhiteTextBox classes={textContainerClasses}>{children}</WhiteTextBox>
                </div>
            </div>
        </div>
    );
}
